import api from './axiosInstance';

export interface BulkUserResult {
  successful: Array<{
    row: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    user: any;
    username: string;
  }>;
  failed: Array<{
    row: number;
    username?: string;
    error: string;
  }>;
  summary: {
    total: number;
    successful: number;
    failed: number;
    skipped: number;
  };
}

export const bulkUserService = {
  // Create multiple users from uploaded file
  async bulkCreateFromFile(file: File, skipExisting: boolean = true): Promise<BulkUserResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('skipExisting', skipExisting.toString());

    const response = await api.post('/api/keycloak/users/bulk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
};
